var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fullname != '')?_c('div',{staticClass:"avatar2",style:(_vm.style)},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }